export enum enumAddressType {
  RESIDENCE = 1,
  CORPORATE_OFFICE = 2,
  WAREHOUSE = 3,
  RETAIL_LOCATION = 4,
  OFFICE_BUILDING = 5,
  BUSINESS_SERVICE_CENTER = 6,
  POST_OFFICE_BOX = 7,
  OTHER = 8,
}
